import { apiClient } from './axios';

import type {
  ActivityLog,
  ActivityLogFacets,
  ActivityLogQuery,
  PaginatedResponse,
} from '@repo/shared-types';

export const activityLogApi = {
  getAll: async (query: Partial<ActivityLogQuery> = {}) => {
    const response = await apiClient.get<PaginatedResponse<ActivityLog>>('/activity-log', {
      params: query,
    });
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<ActivityLog>(`/activity-log/${id}`);
    return response.data;
  },

  getFacets: async () => {
    const response = await apiClient.get<ActivityLogFacets>('/activity-log/facets');
    return response.data;
  },
};
